import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://caspian-inventory.lemueltech.com/inventory'
  // baseURL: 'http://localhost:4900/inventory'
  // baseURL: 'http://192.168.43.42:4900/inventory',
})

export default Axios;
